import React, { memo, SVGProps } from 'react';

interface IProps extends SVGProps<SVGSVGElement> {
	className?: string;
}

const MegaNavFrame: React.FC<IProps> = (props) => {
	return (
		<svg
			width="498"
			height="252"
			viewBox="0 0 498 252"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M101.812 1.21158C114.057 -1.86463 180.18 1.98063 191.609 1.21158H280.59H380.182H451.204C458.551 1.21158 481.408 8.90212 489.571 16.5926C497.735 24.2832 492.837 24.2832 492.837 28.1284V57.3524C492.837 61.0439 495.558 92.2161 496.918 107.341C497.735 135.283 498.877 192.552 496.918 198.089C494.469 205.01 496.918 214.239 489.571 227.313C482.224 240.387 482.224 233.465 472.428 236.542C462.632 239.618 443.857 244.232 437.326 243.463C430.795 242.694 394.876 245.77 370.386 248.077C345.896 250.385 332.835 248.077 313.243 248.077C293.651 248.077 253.651 251.154 229.16 248.077C204.67 245.001 182.629 248.077 178.548 248.077C174.466 248.077 87.1182 248.077 83.0365 251.154C79.7712 253.615 46.3015 250.128 29.9748 248.077C26.1651 241.156 18.5456 226.236 18.5456 221.93C18.5456 216.546 8.74958 205.779 8.74958 191.167C8.74958 176.555 3.8521 124.26 0.586763 114.262C-2.67858 104.265 8.74958 73.5025 8.74958 63.5048C8.74958 53.5071 6.30058 35.0499 8.74958 28.1284C11.1986 21.207 13.6476 20.4379 18.5456 16.5926C23.4436 12.7474 29.158 11.9783 63.444 8.90212C97.7301 5.82591 89.5667 4.28778 101.812 1.21158Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default memo(MegaNavFrame);
